import script from "./ListBulletIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./ListBulletIcon.vue?vue&type=script&setup=true&lang=js"

export default script